export default "__VITE_ASSET__C2sIAkr2__"